import { color } from '@upstox/upstox-ui';

export const wrapper: CSSFunction = () => ({
  height: '100%',
  width: '100%',
});

export const loading: CSSFunction<{ theme: ThemeKeys }> = ({ theme }) => ({
  height: '100%',
  width: '100%',
  backgroundColor: color(theme, 'background.default'),
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
});
